import {
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
} from "@/components/ui/drawer";
import Text from "@/components/Text";
import { type FC } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import type { RestaurantDetails } from "@/API";
import RestaurantPromotion from "@/components/RestaurantPromotion";

type Props = {
  restaurant: RestaurantDetails | null;
  open: boolean;
  onClose: VoidFunction;
};

const DrawerPromotionDetails: FC<Props> = ({ restaurant, open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Drawer
      direction="bottom"
      open={open}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DrawerContent>
        <DrawerHeader
          style={{
            borderBottom: "1px solid #F1F2F4",
          }}
        >
          <div className="flex justify-between items-center">
            <Text fontSize={24} fontWeight={600}>
              {t("promotions")}
            </Text>
            <X
              height={20}
              width={20}
              className="cursor-pointer"
              onClick={() => {
                onClose();
              }}
            />
          </div>
        </DrawerHeader>

        <div
          style={{
            height: "calc(100vh - 10px)",
          }}
          className="flex flex-col gap-[32px] p-[24px] overflow-y-auto"
        >
          <RestaurantPromotion restaurant={restaurant} />
        </div>

        <DrawerFooter
          style={{
            borderTop: "1px solid #F1F2F4",
          }}
        >
          <div className="flex justify-end gap-[8px]">
            <Button
              onClick={() => {
                onClose();
              }}
            >
              {t("close")}
            </Button>
          </div>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default DrawerPromotionDetails;
